// generated by image-library-generator.sh
// check README for more info

enum Images {
  medium = "/medium.svg",
  marinade_logo_white = "/marinade-logo-white.svg",
  sdk = "/sdk.svg",
  pools_msolsollp = "/pools/msolsollp.png",
  nft_details_meta = "/nft-details-meta.png",
  marinade_icon_black = "/marinade-icon-black.svg",
  flags_hn = "/flags/hn.svg",
  flags_dm = "/flags/dm.svg",
  flags_fr = "/flags/fr.svg",
  flags_dz = "/flags/dz.svg",
  flags_ga = "/flags/ga.svg",
  flags_ph = "/flags/ph.svg",
  flags_ss = "/flags/ss.svg",
  flags_rw = "/flags/rw.svg",
  flags_sd = "/flags/sd.svg",
  flags_se = "/flags/se.svg",
  flags_sr = "/flags/sr.svg",
  flags_eh = "/flags/eh.svg",
  flags_gw = "/flags/gw.svg",
  flags_es_pv = "/flags/es-pv.svg",
  flags_jp = "/flags/jp.svg",
  flags_hm = "/flags/hm.svg",
  flags_je = "/flags/je.svg",
  flags_gu = "/flags/gu.svg",
  flags_gb = "/flags/gb.svg",
  flags_pk = "/flags/pk.svg",
  flags_sg = "/flags/sg.svg",
  flags_ru = "/flags/ru.svg",
  flags_do = "/flags/do.svg",
  flags_gt = "/flags/gt.svg",
  flags_kw = "/flags/kw.svg",
  flags_sh_hl = "/flags/sh-hl.svg",
  flags_il = "/flags/il.svg",
  flags_gg = "/flags/gg.svg",
  flags_gp = "/flags/gp.svg",
  flags_dk = "/flags/dk.svg",
  flags_sb = "/flags/sb.svg",
  flags_py = "/flags/py.svg",
  flags_pn = "/flags/pn.svg",
  flags_st = "/flags/st.svg",
  flags_sc = "/flags/sc.svg",
  flags_dj = "/flags/dj.svg",
  flags_gq = "/flags/gq.svg",
  flags_gf = "/flags/gf.svg",
  flags_kr = "/flags/kr.svg",
  flags_im = "/flags/im.svg",
  flags_ke = "/flags/ke.svg",
  flags_kg = "/flags/kg.svg",
  flags_gb_nir = "/flags/gb-nir.svg",
  flags_hk = "/flags/hk.svg",
  flags_kp = "/flags/kp.svg",
  flags_io = "/flags/io.svg",
  flags_gd = "/flags/gd.svg",
  flags_gs = "/flags/gs.svg",
  flags_sa = "/flags/sa.svg",
  flags_re = "/flags/re.svg",
  flags_pm = "/flags/pm.svg",
  flags_sv = "/flags/sv.svg",
  flags_rs = "/flags/rs.svg",
  flags_pl = "/flags/pl.svg",
  flags_gr = "/flags/gr.svg",
  flags_ge = "/flags/ge.svg",
  flags_in = "/flags/in.svg",
  flags_mv = "/flags/mv.svg",
  flags_lr = "/flags/lr.svg",
  flags_ma = "/flags/ma.svg",
  flags_nz = "/flags/nz.svg",
  flags_au = "/flags/au.svg",
  flags_bn = "/flags/bn.svg",
  flags_by = "/flags/by.svg",
  flags_tt = "/flags/tt.svg",
  flags_ug = "/flags/ug.svg",
  flags_tc = "/flags/tc.svg",
  flags_es_ct = "/flags/es-ct.svg",
  flags_ye = "/flags/ye.svg",
  flags_ck = "/flags/ck.svg",
  flags_bo = "/flags/bo.svg",
  flags_at = "/flags/at.svg",
  flags_ls = "/flags/ls.svg",
  flags_mw = "/flags/mw.svg",
  flags_nl = "/flags/nl.svg",
  flags_mu = "/flags/mu.svg",
  flags_ci = "/flags/ci.svg",
  flags_bm = "/flags/bm.svg",
  flags_bz = "/flags/bz.svg",
  flags_tw = "/flags/tw.svg",
  flags_us = "/flags/us.svg",
  flags_vi = "/flags/vi.svg",
  flags_tv = "/flags/tv.svg",
  flags_bl = "/flags/bl.svg",
  flags_aw = "/flags/aw.svg",
  flags_ch = "/flags/ch.svg",
  flags_mc = "/flags/mc.svg",
  flags_mt = "/flags/mt.svg",
  flags_no = "/flags/no.svg",
  flags_lc = "/flags/lc.svg",
  flags_mg = "/flags/mg.svg",
  flags_lt = "/flags/lt.svg",
  flags_mp = "/flags/mp.svg",
  flags_ad = "/flags/ad.svg",
  flags_cl = "/flags/cl.svg",
  flags_as = "/flags/as.svg",
  flags_bh = "/flags/bh.svg",
  flags_ua = "/flags/ua.svg",
  flags_tr = "/flags/tr.svg",
  flags_sh_ta = "/flags/sh-ta.svg",
  flags_yt = "/flags/yt.svg",
  flags_td = "/flags/td.svg",
  flags_bi = "/flags/bi.svg",
  flags_ar = "/flags/ar.svg",
  flags_cm = "/flags/cm.svg",
  flags_ae = "/flags/ae.svg",
  flags_cz = "/flags/cz.svg",
  flags_mq = "/flags/mq.svg",
  flags_lu = "/flags/lu.svg",
  flags_mf = "/flags/mf.svg",
  flags_lb = "/flags/lb.svg",
  flags_md = "/flags/md.svg",
  flags_ms = "/flags/ms.svg",
  flags_ag = "/flags/ag.svg",
  flags_cx = "/flags/cx.svg",
  flags_sh_ac = "/flags/sh-ac.svg",
  flags_co = "/flags/co.svg",
  flags_tf = "/flags/tf.svg",
  flags_vn = "/flags/vn.svg",
  flags_zm = "/flags/zm.svg",
  flags_gb_sct = "/flags/gb-sct.svg",
  flags_tg = "/flags/tg.svg",
  flags_cn = "/flags/cn.svg",
  flags_bj = "/flags/bj.svg",
  flags_aq = "/flags/aq.svg",
  flags_cy = "/flags/cy.svg",
  flags_af = "/flags/af.svg",
  flags_lv = "/flags/lv.svg",
  flags_om = "/flags/om.svg",
  flags_mr = "/flags/mr.svg",
  flags_ni = "/flags/ni.svg",
  flags_la = "/flags/la.svg",
  flags_me = "/flags/me.svg",
  flags_mh = "/flags/mh.svg",
  flags_gb_wls = "/flags/gb-wls.svg",
  flags_cc = "/flags/cc.svg",
  flags_bg = "/flags/bg.svg",
  flags_tj = "/flags/tj.svg",
  flags_un = "/flags/un.svg",
  flags_vu = "/flags/vu.svg",
  flags_wf = "/flags/wf.svg",
  flags_uy = "/flags/uy.svg",
  flags_za = "/flags/za.svg",
  flags_zw = "/flags/zw.svg",
  flags_vc = "/flags/vc.svg",
  flags_tk = "/flags/tk.svg",
  flags_bf = "/flags/bf.svg",
  flags_bq = "/flags/bq.svg",
  flags_cu = "/flags/cu.svg",
  flags_ne = "/flags/ne.svg",
  flags_nr = "/flags/nr.svg",
  flags_mk = "/flags/mk.svg",
  flags_np = "/flags/np.svg",
  flags_ng = "/flags/ng.svg",
  flags_bs = "/flags/bs.svg",
  flags_cw = "/flags/cw.svg",
  flags_bd = "/flags/bd.svg",
  flags_um = "/flags/um.svg",
  flags_va = "/flags/va.svg",
  flags_uz = "/flags/uz.svg",
  flags_xk = "/flags/xk.svg",
  flags_ws = "/flags/ws.svg",
  flags_th = "/flags/th.svg",
  flags_ca = "/flags/ca.svg",
  flags_be = "/flags/be.svg",
  flags_cv = "/flags/cv.svg",
  flags_ai = "/flags/ai.svg",
  flags_br = "/flags/br.svg",
  flags_ly = "/flags/ly.svg",
  flags_nf = "/flags/nf.svg",
  flags_my = "/flags/my.svg",
  flags_mn = "/flags/mn.svg",
  flags_nu = "/flags/nu.svg",
  flags_az = "/flags/az.svg",
  flags_ba = "/flags/ba.svg",
  flags_bv = "/flags/bv.svg",
  flags_am = "/flags/am.svg",
  flags_cr = "/flags/cr.svg",
  flags_tl = "/flags/tl.svg",
  flags_xx = "/flags/xx.svg",
  flags_tm = "/flags/tm.svg",
  flags_tz = "/flags/tz.svg",
  flags_ve = "/flags/ve.svg",
  flags_al = "/flags/al.svg",
  flags_bw = "/flags/bw.svg",
  flags_cd = "/flags/cd.svg",
  flags_lk = "/flags/lk.svg",
  flags_mo = "/flags/mo.svg",
  flags_mx = "/flags/mx.svg",
  flags_nc = "/flags/nc.svg",
  flags_na = "/flags/na.svg",
  flags_mz = "/flags/mz.svg",
  flags_li = "/flags/li.svg",
  flags_mm = "/flags/mm.svg",
  flags_cf = "/flags/cf.svg",
  flags_cefta = "/flags/cefta.svg",
  flags_bb = "/flags/bb.svg",
  flags_vg = "/flags/vg.svg",
  flags_to = "/flags/to.svg",
  flags_tn = "/flags/tn.svg",
  flags_ao = "/flags/ao.svg",
  flags_bt = "/flags/bt.svg",
  flags_cp = "/flags/cp.svg",
  flags_ax = "/flags/ax.svg",
  flags_cg = "/flags/cg.svg",
  flags_ml = "/flags/ml.svg",
  flags_jo = "/flags/jo.svg",
  flags_it = "/flags/it.svg",
  flags_ic = "/flags/ic.svg",
  flags_gh = "/flags/gh.svg",
  flags_sm = "/flags/sm.svg",
  flags_pa = "/flags/pa.svg",
  flags_sz = "/flags/sz.svg",
  flags_eac = "/flags/eac.svg",
  flags_gb_eng = "/flags/gb-eng.svg",
  flags_es_ga = "/flags/es-ga.svg",
  flags_pw = "/flags/pw.svg",
  flags_sl = "/flags/sl.svg",
  flags_de = "/flags/de.svg",
  flags_gi = "/flags/gi.svg",
  flags_fm = "/flags/fm.svg",
  flags_kh = "/flags/kh.svg",
  flags_et = "/flags/et.svg",
  flags_fo = "/flags/fo.svg",
  flags_dg = "/flags/dg.svg",
  flags_ec = "/flags/ec.svg",
  flags_sn = "/flags/sn.svg",
  flags_sy = "/flags/sy.svg",
  flags_sx = "/flags/sx.svg",
  flags_pc = "/flags/pc.svg",
  flags_pt = "/flags/pt.svg",
  flags_so = "/flags/so.svg",
  flags_eu = "/flags/eu.svg",
  flags_jm = "/flags/jm.svg",
  flags_hr = "/flags/hr.svg",
  flags_ki = "/flags/ki.svg",
  flags_kz = "/flags/kz.svg",
  flags_ie = "/flags/ie.svg",
  flags_km = "/flags/km.svg",
  flags_ir = "/flags/ir.svg",
  flags_gy = "/flags/gy.svg",
  flags_gn = "/flags/gn.svg",
  flags_fj = "/flags/fj.svg",
  flags_pg = "/flags/pg.svg",
  flags_sk = "/flags/sk.svg",
  flags_ro = "/flags/ro.svg",
  flags_sj = "/flags/sj.svg",
  flags_pf = "/flags/pf.svg",
  flags_fk = "/flags/fk.svg",
  flags_eg = "/flags/eg.svg",
  flags_is = "/flags/is.svg",
  flags_id = "/flags/id.svg",
  flags_ky = "/flags/ky.svg",
  flags_iq = "/flags/iq.svg",
  flags_kn = "/flags/kn.svg",
  flags_hu = "/flags/hu.svg",
  flags_ee = "/flags/ee.svg",
  flags_er = "/flags/er.svg",
  flags_fi = "/flags/fi.svg",
  flags_gm = "/flags/gm.svg",
  flags_sh = "/flags/sh.svg",
  flags_ps = "/flags/ps.svg",
  flags_arab = "/flags/arab.svg",
  flags_pr = "/flags/pr.svg",
  flags_si = "/flags/si.svg",
  flags_pe = "/flags/pe.svg",
  flags_qa = "/flags/qa.svg",
  flags_gl = "/flags/gl.svg",
  flags_es = "/flags/es.svg",
  flags_ht = "/flags/ht.svg",
  github = "/github.svg",
  marinade = "/marinade.png",
  i404 = "/404.svg",
  logos_Orca = "/logos/Orca.svg",
  logos_Hubble = "/logos/Hubble.svg",
  logos_Marinade = "/logos/Marinade.svg",
  logos_locked_deactivated_account_validator = "/logos/locked_deactivated_account_validator.svg",
  logos_Mercurial = "/logos/Mercurial.svg",
  logos_solflare_white = "/logos/solflare_white.svg",
  logos_phantom_white = "/logos/phantom_white.svg",
  logos_Raydium = "/logos/Raydium.svg",
  logos_coinbase_wallet_white = "/logos/coinbase_wallet_white.svg",
  logos_Solend = "/logos/Solend.svg",
  meta_img_isps = "/meta-img/isps.png",
  meta_img_app = "/meta-img/app.png",
  meta_img_terms = "/meta-img/terms.png",
  meta_img_liquidity = "/meta-img/liquidity.png",
  meta_img_mnde = "/meta-img/mnde.png",
  meta_img_contact = "/meta-img/contact.png",
  meta_img_earn = "/meta-img/earn.png",
  meta_img_landing = "/meta-img/landing.png",
  meta_img_validators = "/meta-img/validators.png",
  meta_img_validators_comparison = "/meta-img/validators-comparison.png",
  meta_img_network = "/meta-img/network.png",
  meta_img_staking = "/meta-img/staking.png",
  meta_img_estimates = "/meta-img/estimates.png",
  meta_img_msol = "/meta-img/msol.png",
  meta_img_countries = "/meta-img/countries.png",
  marinade_logo_black = "/marinade-logo-black.svg",
  favicon = "/favicon.png",
  ilustrations_burned = "/ilustrations/burned.svg",
  ilustrations_highlight_background = "/ilustrations/highlight-background.png",
  ilustrations_burn = "/ilustrations/burn.svg",
  ilustrations_mnde_reward = "/ilustrations/mnde_reward.svg",
  ilustrations_relock = "/ilustrations/relock.svg",
  ilustrations_orange_checkmark = "/ilustrations/orange-checkmark.svg",
  ilustrations_unlock = "/ilustrations/unlock.svg",
  ilustrations_waiting = "/ilustrations/waiting.svg",
  ilustrations_green_checkmark = "/ilustrations/green-checkmark.svg",
  ilustrations_relocked = "/ilustrations/relocked.svg",
  marinade_icon_white = "/marinade-icon-white.svg",
  icons_arrow_down = "/icons/arrow-down.svg",
  icons_laineSOL = "/icons/laineSOL.svg",
  icons_solana_foundation = "/icons/solana-foundation.svg",
  icons_mnde = "/icons/mnde.svg",
  icons_expand_more = "/icons/expand-more.svg",
  icons_clock_orange = "/icons/clock_orange.svg",
  icons_external_link_black = "/icons/external-link-black.svg",
  icons_stake_arrow = "/icons/stake_arrow.svg",
  icons_directed_to_marinade = "/icons/directed-to-marinade.svg",
  icons_expand_more_black = "/icons/expand-more-black.svg",
  icons_governance_icon = "/icons/governance_icon.svg",
  icons_info_blue = "/icons/info_blue.svg",
  icons_ic_participate = "/icons/ic_participate.svg",
  icons_arrow_right = "/icons/arrow-right.svg",
  icons_coins_plus = "/icons/coins_plus.svg",
  icons_coins_flag = "/icons/coins_flag.svg",
  icons_settings = "/icons/settings.svg",
  icons_stacking = "/icons/stacking.svg",
  icons_jSOL = "/icons/jSOL.svg",
  icons_coins_lock_primary = "/icons/coins_lock_primary.svg",
  icons_mnde_rewards = "/icons/mnde_rewards.svg",
  icons_scales = "/icons/scales.svg",
  icons_daoSOL = "/icons/daoSOL.png",
  icons_wallet = "/icons/wallet.svg",
  icons_sorting_icon = "/icons/sorting-icon.svg",
  icons_options_gear = "/icons/options_gear.svg",
  icons_stake_arrow_green = "/icons/stake_arrow_green.svg",
  icons_ribon = "/icons/ribon.svg",
  icons_twitter_black = "/icons/twitter-black.svg",
  icons_check = "/icons/check.svg",
  icons_blazeSOL = "/icons/blazeSOL.svg",
  icons_lidoSOL = "/icons/lidoSOL.svg",
  icons_coins_lock = "/icons/coins_lock.svg",
  icons_external_link_red = "/icons/external-link-red.svg",
  icons_solana_dark = "/icons/solana-dark.png",
  icons_copy_identity = "/icons/copy_identity.svg",
  icons_mSOL = "/icons/mSOL.svg",
  icons_directed_to_validator = "/icons/directed-to-validator.svg",
  icons_external_link_white = "/icons/external-link-white.svg",
  icons_check_mark = "/icons/check_mark.svg",
  icons_warning_yellow = "/icons/warning_yellow.svg",
  icons_arrow_right_green = "/icons/arrow-right-green.svg",
  icons_info_grey = "/icons/info_grey.svg",
  icons_staker_claim = "/icons/staker-claim.svg",
  icons_discord_drawn_round = "/icons/discord-drawn-round.svg",
  icons_referrer_claim = "/icons/referrer-claim.svg",
  icons_copy_vote = "/icons/copy_vote.svg",
  icons_jitoSOL = "/icons/jitoSOL.svg",
  icons_coins_liquid_primary = "/icons/coins_liquid_primary.svg",
  icons_cgntSOL = "/icons/cgntSOL.svg",
  icons_coins_liquid = "/icons/coins_liquid.svg",
  icons_marinade_black = "/icons/marinade_black.svg",
  icons_arrow_right_white = "/icons/arrow-right-white.svg",
  icons_twitter = "/icons/twitter.svg",
  icons_external_link_green = "/icons/external-link-green.svg",
  icons_pointer_down_black = "/icons/pointer-down-black.svg",
  icons_mSOL_SOL_LP = "/icons/mSOL-SOL LP.svg",
  icons_check_rounded = "/icons/check_rounded.svg",
  icons_buy_yours = "/icons/buy-yours.svg",
  icons_max = "/icons/max.svg",
  icons_arrow_down_black_fill = "/icons/arrow-down-black-fill.svg",
  marinade_meta = "/marinade-meta.png",
  discord_black = "/discord-black.svg",
  discord = "/discord.svg",
  ic_twitter_24 = "/ic_twitter_24.svg",
  error = "/error.svg",
  favicon_v1 = "/favicon.svg",
  onboarding_app_step1 = "/onboarding/app_step1.gif",
  onboarding_app_step3 = "/onboarding/app_step3.gif",
  onboarding_app_step2 = "/onboarding/app_step2.gif",
}

export default Images;
